// Static configuration for the frontend
const searchUrl = process.env.SITE_SEARCH_URL;

module.exports = {
  search: {
    defaultIndexName: "prod_color_variant_products",
    suggestionIndexName: "prod_color_variant_products__query_suggestions",
    suggestionIndexFacetFilters: [
      "prod_color_variant_products.facets.exact_matches._tags.value:site"
    ], // Only suggest results tagged with 'site'
    featuredCollectionIndexName: "prod_color_variant_products__groupby_style",
    url: searchUrl,
    resultScopeOptions: [
      {
        id: "all",
        title: "All",
        titleSingular: "All",
        resultDisplayType: "color",
        indexName: "prod_color_variant_products",
        searchParameters: {
          restrictSearchableAttributes: []
        },
        seeAllLinkTitle: "See all search results"
      },
      {
        id: "collections",
        title: "Collections",
        titleSingular: "Collection",
        resultDisplayType: "color",
        indexName: "prod_color_variant_products",
        searchParameters: {
          restrictSearchableAttributes: ["collectionCode.description"]
        },
        seeAllLinkTitle: "See all collection results"
      },
      {
        id: "styles",
        title: "Styles",
        titleSingular: "Style",
        resultDisplayType: "color",
        indexName: "prod_color_variant_products",
        searchParameters: {
          restrictSearchableAttributes: [
            "sellingStyleName",
            "sellingStyleNumber",
            "inventoryType",
            "productTypeDesc"
          ]
        },
        seeAllLinkTitle: "See all styles results"
      },
      {
        id: "swatch-colors",
        title: "Swatch colors",
        titleSingular: "Swatch color",
        resultDisplayType: "color",
        indexName: "prod_color_variant_products",
        searchParameters: {
          restrictSearchableAttributes: [
            "colors.colorName",
            "colors.colorNumber"
          ]
        },
        seeAllLinkTitle: "See all swatch color results"
      },
      {
        id: "page-content",
        title: "Page content",
        resultDisplayType: "content",
        indexName: "prod_page_content",
        searchParameters: {
          restrictSearchableAttributes: []
        },
        seeAllLinkTitle: "See all site content results",
        skipResultsPreview: true
      }
    ],
    resultScopeOptionsNew: [
      {
        id: "collections",
        title: "Collections",
        titleSingular: "Collection",
        resultDisplayType: "color",
        indexName: "prod_color_variant_products",
        searchParameters: {
          restrictSearchableAttributes: ["collectionCode.description"]
        },
        seeAllLinkTitle: "See all collection results"
      },
      {
        id: "styles",
        title: "Styles",
        titleSingular: "Style",
        resultDisplayType: "color",
        indexName: "prod_color_variant_products",
        searchParameters: {
          restrictSearchableAttributes: [
            "sellingStyleName",
            "sellingStyleNumber",
            "inventoryType",
            "productTypeDesc"
          ]
        },
        seeAllLinkTitle: "See all styles results"
      },
      {
        id: "page-content",
        title: "Page content",
        resultDisplayType: "content",
        indexName: "prod_page_content",
        searchParameters: {
          restrictSearchableAttributes: []
        },
        seeAllLinkTitle: "See all site content results",
        skipResultsPreview: true
      }
    ],
    productCategoryIndexGroups: [
      {
        group: "collection",
        title: "Collections",
        showQuickView: false,
        resultDisplayType: "collection",
        indices: [
          {
            indexId: "collections_featured",
            sortOrder: "featured",
            indexName: "prod_color_variant_products__groupby_collection"
          },
          {
            indexId: "collections_name",
            sortOrder: "name",
            indexName:
              "prod_color_variant_products__groupby_collection__sortby_name"
          }
        ]
      },
      {
        group: "style",
        title: "Styles",
        showQuickView: true,
        resultDisplayType: "style",
        indices: [
          {
            indexId: "styles_featured",
            sortOrder: "featured",
            indexName: "prod_color_variant_products__groupby_style"
          },
          {
            indexId: "styles_name",
            sortOrder: "name",
            indexName: "prod_color_variant_products__groupby_style__sortby_name"
          }
        ]
      }
    ],
    productFacetNameMappings: {
      "colors.customPdqID": {
        "1": "pdQ Available"
      },
      "colors.isInStock": {
        true: "Show In Stock"
      }
    },
    defaultTrycicleCode: "1"
  },
  queryParamNames: {
    INSTALLATION_QUERY_PARAM_NAME: "installation-method",
    ROOM_SCENE_QUERY_PARAM_NAME: "room-scene",
    CATEGORY_QUERY_PARAM_NAME: "category"
  },
  enum: {
    checkOutType: {
      Tray: 0,
      Site: 1,
      Mixed: 2
    }
  }
};
